import { ENDPOINT_PERSONAL_ACCESS_TOKENS } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const revokePersonalAccessToken = async (id: string): Promise<void> => {
  await AuthAxios.delete(`${ENDPOINT_PERSONAL_ACCESS_TOKENS}/${id}`)
}

export default revokePersonalAccessToken
